import script from "./Level.vue?vue&type=script&lang=ts&setup=true"
export * from "./Level.vue?vue&type=script&lang=ts&setup=true"

import "./Level.vue?vue&type=style&index=0&id=3fb5465e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb5465e"]])

export default __exports__